/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Driver_View_AvailableInputs */

const vi_dashboard_driver_view_available = /** @type {(inputs: Dashboard_Driver_View_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xem đơn chờ nhận`)
};

/**

* @param {Dashboard_Driver_View_AvailableInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dashboard_driver_view_available = /** @type {((inputs?: Dashboard_Driver_View_AvailableInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Driver_View_AvailableInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dashboard_driver_view_available(inputs)
});